export default (state = [], action) => {
  switch (action.type) {
    case 'SMART_LINK_DETAIL_GET_REQUEST': {
      const matchingSmartLink = state.find(smart_link => smart_link.url === action.payload.url);
      if (!matchingSmartLink) return [...state, { ...action.payload, loading: true }];
      return state.map(smart_link => {
        if (smart_link.url === action.payload.url) return { ...smart_link, loading: true };
        return smart_link;
      });
    }
    case 'SMART_LINK_DETAIL_GET_RESPONSE':
      if (action.data) {
        const matchingSmartLink = state.find(smart_link => smart_link.url === action.data.url);
        if (!matchingSmartLink) return [...state, action.data];
        return state.map(smart_link => {
          if (smart_link.url === action.data.url) return action.data;
          return smart_link;
        });
      }
      return state;
    default:
      return state;
  }
};
